export default "/images/b20961a904108101b888c00ea7dc6de9.avif";